<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="customerUsersHeadings" :data="customerUsers" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onCustomerUserActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button id="btnAddCustomerUser" class="btn btn-primary" @click="onAddCustomerUserClick">Add Customer User</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="pb-4">
                                    <label>Role</label>
                                    <bootstrap-select  :selectOptions="customerUserRoles" :selectedOption="filter.selectedCustomerUserRoleId" :elementId="'roleFilterSelect'"
                                                       :returnSelectedOptionText="true"
                                                       @changeSelect="onRoleFilterSelect"></bootstrap-select>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="customerUserMarkAsActiveInactiveModal.heading"
                :modalId="customerUserMarkAsActiveInactiveModal.modalId"
                :isSaving="customerUserMarkAsActiveInactiveModal.isSaving"
                :showModal="customerUserMarkAsActiveInactiveModal.showModal"
                :isActive="customerUserMarkAsActiveInactiveModal.isActive"
                @closeClicked="customerUserMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <assign-vehicle-to-customer-user-modal
                :heading="assignVehicleToCustomerUserModal.heading"
                :modalId="assignVehicleToCustomerUserModal.modalId"
                :showModal="assignVehicleToCustomerUserModal.showModal"
                :userId="assignVehicleToCustomerUserModal.userId"
                :companyId="companyId"
                @assignVehicleToCustomerUserModalOkClicked="onAssignVehicleToCustomerUserModalOkClicked"></assign-vehicle-to-customer-user-modal>

    <password-generator-modal
                :modalId="userPasswordResetModal.modalId"
                :userId="userPasswordResetModal.userId"
                :showModal="userPasswordResetModal.showModal"
                :username="userPasswordResetModal.username"
                @passwordGeneratorOkClicked="onPasswordGeneratorOkClicked"></password-generator-modal>
</div>
